import * as React from "react";
import styleable from "react-styleable";
import { Link } from "react-router-dom";
import * as styles from "../../../css/components/mainlayout/languagechoice.css";
import {changeLocale} from "../../actions/LanguageActions";
import {t} from 'ttag';

class LanguageChoice extends React.Component<any> {

    changeLanguage(click, language, i18n) {
        click.preventDefault();
        changeLocale(language, i18n);
    }

    render() {
        let output = [];
        const i18n = this.props.i18n;
        for (const language of this.props.languages)
        {
            output.push(<Link key={language} to={language} onClick={(e) => this.changeLanguage(e, language, i18n)} className={(language === t`locale` ? this.props.css.active : this.props.css.inactive)}>
                            {language}
                        </Link>
                       );
        }

        return (<div className={this.props.css.languagechoice + ' ' + styles.languagechoice}>{output}</div>);
    }
}
export default styleable(styles)(LanguageChoice);